import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  CallBreakdown,
  CallBreakdownDetails,
} from 'src/app/model/call/call.model';
import { Pannes } from '../../../model/incidents/pannes.model';
import { PannesMachine } from '../../../model/incidents/pannesList.model';
import { IncidentsSuivi } from '../../../model/incidents/pannesSuivi.model';
import {
  APIUrls,
  WebConfigurationService,
} from '../common/web-configuration.service';

@Injectable({
  providedIn: 'root',
})
export class IncidentsService extends WebConfigurationService {
  constructor(protected http: HttpClient) {
    super(http);
  }

  /**
   * Get the 'Incidents' json data
   * @returns an Observable
   */
  public getIncidentsData(): Observable<Pannes> {
    return this.authGetObs<Pannes>(APIUrls.getIncidentsUrl());
  }

  /**
   * Get the 'IncidentsSuivi' json data
   * @returns an Observable
   */
  public getIncidentsSuiviData(): Observable<IncidentsSuivi> {
    return this.authGetObs<IncidentsSuivi>(APIUrls.getIncidentsSuiviUrl());
  }

  /**
   * Get the 'PannesList' json data
   * @returns an Observable
   */
  public getPannesMachineData(id: string): Observable<PannesMachine> {
    return this.authGetObs<PannesMachine>(this.getPannesMachineUrl(id));
  }

  public getPannesStats(
    startDate: Date,
    endDate: Date
  ): Observable<CallBreakdown[]> {
    let sDate = this.getFormattedDate(startDate);
    endDate.setDate(endDate.getDate() + 1); // Add 1 day to end date to include it in sql request
    let eDate = this.getFormattedDate(endDate);
    return this.authGetObs<CallBreakdown[]>(
      this.getPanneStatsUrl(sDate, eDate)
    );
  }

  public getPannesStatsDetails(startDate: Date, endDate: Date) {
    let sDate = this.getFormattedDate(startDate);
    //endDate.setDate( endDate.getDate() + 1); // Add 1 day to end date to include it in sql request
    let eDate = this.getFormattedDate(endDate);
    return this.authGetObs<CallBreakdownDetails[]>(
      this.getPanneStatsDetailsUrl(sDate, eDate)
    );
  }

  public getIdInstallationsByDate(startDate: Date, endDate: Date) {
    let sDate = this.getFormattedDate(startDate);
    let eDate = this.getFormattedDate(endDate);
    return this.authGetObs<any>(this.getIdInstallationsByDateUrl(sDate, eDate));
  }
}
